<template>
  <div class="root">
    <div class="header-box" :class="addBackground">
      <div class="c-header" :class="headerClass">
        <div class="header-logo">
          <a href="/">
            <img v-if="addBackground === ''" src="./images/header-logo-white-xd.png">
            <img v-else src="./images/header-logo-orange-xd.png">
          </a>
        </div>
        <!-- <div class="credit">
          <a href="javascript:;" @click.prevent="showQrcode">征信查询</a>
          <div class="qrcode-box">
            <i class="close-btn" @click="closeQrcode"></i>
            <div class="qrcode-content">
              <p>风险信用不可小觑</p>
              <p>您有一份征信报告待查看</p>
              <div class="qrcode" id="qrcode" ref="qrcode"></div>
              <div class="foot">扫码即刻查征信</div>
            </div>
          </div>
        </div> -->
        <ul class="nav">
          <li v-for="(item,index) in navList" :key="index">
            <a @click="goUrl(item.url)" :class="{ active:index==currentPage}">{{item.name}}</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="introduce">
      <dl>
        <dt id="Introduce">
          公司简介
        </dt>
        <dd>
          八戒小贷全称为重庆市猪八戒宜创小额贷款有限公司，成立于2016年5月，注册资本金30000万元人民币。是由重庆市金融办批准成立的正规非银行金融机构，是全国第19家有牌照的互联网小贷公司。公司成立于2016年，致力于为猪八戒网用户乃至更多的小微企业及企业主提供数字普惠金融服务，助力数字普惠金融在中国的发展，同时结合创新互联网技术，将传统金融与大数据、互联网技术相结合，探索全新的科技金融发展模式，搭建开放、共享的体系服务平台。科技金融发展模式，搭建开放、共享的体系服务平台。
        </dd>
      </dl>
    </div>
    <div class="corporate-culture">
      <div class="title" id="Cultrue">企业文化</div>
      <ul>
        <li class="illustration-1"></li>
        <li>
          <dl>
            <dt>
              <img src="./images/icon-mission.png" alt="">
            </dt>
            <dd class="has-line">使命</dd>
            <dd class="word">为用户提供普惠、便捷、优质的金融产品</dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt class="add-top">
              <img src="./images/icon-vision.png" alt="">
            </dt>
            <dd class="has-line">愿景</dd>
            <dd class="word">建设中国领先的数据</dd>
            <dd class="word">普惠金融服务平台</dd>
          </dl>
        </li>
        <li class="illustration-2"></li>
        <li class="illustration-3"></li>
        <li>
          <dl>
            <dt class="add-top">
              <img src="./images/icon-value.png" alt="">
            </dt>
            <dd class="has-line">价值观</dd>
            <dd class="word">关注小微、普惠大众</dd>
          </dl>
        </li>
      </ul>
    </div>
    <div class="introduce-slide">
      <div class="title" id="Course">公司简介</div>
      <div class="slide-box">
        <swiper :options="swiperOption" ref="mySwiper">
          <!-- slides -->
          <swiper-slide v-for="(item,index) in timeLineList" :key="index">
            <div class="item">
              <div class="img">
                <img :src="item.imgUrl" alt="">
                {{item.date}}
              </div>
              <div class="text">
                <h2></h2>
                <p>{{item.content}}</p>
              </div>
            </div>
          </swiper-slide>
        </swiper>
        <div class="swiper-button-prev" @click="getIndex('prev')" slot="button-prev"></div>
        <div class="swiper-button-next" @click="getIndex('next')" slot="button-next"></div>
      </div>
      <div class="time-line">
        <div class="time-line-box" :style="{width:currentWidth+'px',left:currentLeft+'px'}">
          <div class="time-line-item" v-for="(item,index) in timeLineList" :key="index" @click="timeLineHandler(index)">
            <span :class="index === currentIndex?'selected':'not-selected'"></span>
            <p>{{item.date}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let staticLibURI = window.ZBJInfo.staticLibURI;
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import $ from "jquery";
import QRCode from "qrcodejs2";
export default {
  name: "about-us",
  data() {
    return {
      navList: [
        {
          name: "联系我们",
          url: "/contactUs",
        },
        {
          name: "加入我们",
          url: "/joinUsMain",
        },
        {
          name: "公司公告",
          url: "/announcementList",
        },
        {
          name: "场景服务",
          url: "/sceneService",
        },
        {
          name: "关于八戒小贷",
          url: "/aboutUs",
        },
        {
          name: "首页",
          url: "/index",
        },
      ],
      currentPage: 4,
      headerClass: "",
      addBackground: "",
      swiperOption: {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        loop: false,
        speed: 1000,
      },
      timeLineList: [
        { date: "2015年12月", title: "", content: "八戒金融团队筹建,基金完成第一个对外投资项目", imgUrl: "https://pub.jr-zbj.com/zbjfins/jrmh1.png" },
        { date: "2016年1月", title: "", content: "1月11日八戒金融正式成立,同时订单贷项目启动", imgUrl: "https://pub.jr-zbj.com/zbjfins/jrmh2.JPG" },
        { date: "2016年3月", title: "", content: "成立商业保理公司、元创信息技术公司,确立世乐投资为八戒金融控股公司", imgUrl: "https://pub.jr-zbj.com/zbjfins/jrmh3.jpg" },
        { date: "2016年5月", title: "", content: "小贷公司成立，获取小贷牌照,基金管理规模突破10亿", imgUrl: "https://pub.jr-zbj.com/zbjfins/jrmh4.png" },
        { date: "2016年7月", title: "", content: "“订单贷”上线，实现首笔业务投放", imgUrl: "https://pub.jr-zbj.com/zbjfins/jrmh5.png" },
        { date: "2016年9月", title: "", content: "首笔保理业务投放,小贷业务系统上线(试运行)", imgUrl: "https://pub.jr-zbj.com/zbjfins/jrmh6.png" },
        { date: "2017年2月", title: "", content: "八戒金融成立1周年 八戒基金主办猪八戒网首届CEO年会", imgUrl: "https://pub.jr-zbj.com/zbjfins/jrmh7.jpg" },
        { date: "2017年11月", title: "", content: "截止17年11月,八戒速贷、八戒保险、理财频道、提前收款、帮你付、员工贷上线", imgUrl: "https://pub.jr-zbj.com/zbjfins/jrmh8.png" },
        { date: "2018年1月", title: "", content: "八戒金融成立2周年,资产管理规模50亿", imgUrl: "https://pub.jr-zbj.com/zbjfins/jrmh9.JPG" },
        { date: "2018年7月", title: "", content: "虚拟信用卡产品“戒易花”上线,实现首笔借款提现", imgUrl: "https://pub.jr-zbj.com/zbjfins/jrmh10.png" },
        { date: "2018年8月", title: "", content: "医美分期业务上线,布局消费分期场景", imgUrl: "https://pub.jr-zbj.com/zbjfins/jrmh11.png" },
        { date: "2018年8月", title: "", content: "八戒金融受邀参加首届智博会,金融三大智能系统首次对外亮相", imgUrl: "https://pub.jr-zbj.com/zbjfins/jrmh12.jpg" },
        { date: "2018年12月", title: "", content: "2019中关村金融科技论坛暨第六届普惠金融论坛”中获得“2018年度普惠金融竞争力企业”", imgUrl: "https://pub.jr-zbj.com/zbjfins/jrmh13.jpeg" },
        { date: "2019年2月", title: "", content: "成立创业贷项目,为猪八戒网众多小微企业及企业主提供金融服务", imgUrl: "https://pub.jr-zbj.com/zbjfins/jrmh14.png" },
      ],
      currentIndex: 0, // 用于同步轮播和时间轴的选中状态
      currentWidth: 0,
      currentLeft: 0,
      rightEnd: 6,
      leftEnd: 0,
    };
  },
  components: {
    swiper,
    swiperSlide,
  },
  mounted() {
    this.$bus.$emit("ready");
    window.addEventListener("scroll", this.getScroll);
    this.currentWidth = 171 * this.timeLineList.length;
    let id = this.$route.query.scroll || "";
    if (id) {
      document.querySelector("#" + id).scrollIntoView(true);
    }
  },
  methods: {
    goUrl(url) {
      this.$router.push(url);
    },
    // 监听滚动 改变悬浮头部的样式
    getScroll() {
      let scrollTop = 0;
      if (document.documentElement && document.documentElement.scrollTop) {
        scrollTop = document.documentElement.scrollTop;
      } else if (document.body) {
        scrollTop = document.body.scrollTop;
      }
      if (scrollTop > 0) {
        // 这个值每个页面可能都不一样，需要独立计算
        this.headerClass = "white-header";
        this.addBackground = "add-bg";
      } else {
        this.headerClass = "";
        this.addBackground = "";
      }
    },
    timeLineHandler(index) {
      this.changeSelectStatus(index);
      this.$refs.mySwiper.swiper.slideTo(index, 1000, false);
    },
    changeSelectStatus(index) {
      // 控制时间轴移动的方法
      this.currentIndex = index;
      if (index === 0 && this.leftEnd === 0) {
        this.currentLeft = 0;
      } else if (this.leftEnd === 0 && index > this.leftEnd && index < this.rightEnd) {
        this.currentLeft = 0;
      } else if (this.leftEnd === 0 && index === this.rightEnd) {
        this.leftEnd++;
        this.rightEnd++;
        this.currentLeft = -this.leftEnd * 171;
        this.timeLineAnimate(this.currentLeft);
      } else if (this.leftEnd > 0 && index === this.leftEnd) {
        this.leftEnd--;
        this.rightEnd--;
        this.currentLeft = -this.leftEnd * 171;
        this.timeLineAnimate(this.currentLeft);
      } else if (this.leftEnd > 0 && index > this.leftEnd && index < this.rightEnd) {
        // 什么都不变
      } else if (this.leftEnd > 0 && index === this.rightEnd && this.rightEnd < this.timeLineList.length - 1) {
        this.leftEnd++;
        this.rightEnd++;
        this.currentLeft = -this.leftEnd * 171;
        this.timeLineAnimate(this.currentLeft);
      } else {
        // 点击最后一个时间点，可以给个提示
      }
    },
    getIndex(direction) {
      let activeIndex = this.$refs.mySwiper.swiper.activeIndex;
      if (direction === "next") {
        this.changeSelectStatus(activeIndex + 1);
      } else {
        this.changeSelectStatus(activeIndex - 1);
      }
    },
    timeLineAnimate(moveDistance) {
      // 时间轴动画效果
      $(".time-line-box").animate({ left: moveDistance + "px" }, 500);
    },
    showQrcode() {
      $(".qrcode").html("");
      let qrcode = new QRCode("qrcode", {
        width: 154, // 设置宽度
        height: 154, // 设置高度
        text: "https://m.tianxiaxinyong.cn/cooperation/crp-v2/per-detail.html?channel=K3lRa1Z6WE9aY2Iveng0VHNoN2d3Zz09",
      });
      $(".qrcode-box").slideDown(300, "linear", function () {
        $(".qrcode-content").fadeIn(500);
      });
    },
    closeQrcode() {
      $(".qrcode-box").fadeOut();
      $(".qrcode-content").hide();
    },
  },
};
</script>
<style scoped rel="stylesheet/less" lang="less">
@import "..\..\..\global\css\mixin\mixin.less";
.header-box {
  width: 100%;
  height: 104px;
  position: fixed;
  left: 0px;
  top: 0px;
  z-index: 999;
  &.add-bg {
    background: url("./images/white-header-bg.png") no-repeat top center;
  }
}
.c-header {
  font-size: 22px;
  width: 1200px;
  height: 80px;
  line-height: 80px;
  // overflow: hidden;
  margin: 0 auto;
  position: relative;
  .header-logo {
    float: left;
    width: 105px;
    height: 80px;
    text-align: center;
    position: relative;
    img {
      width: 166px;
      vertical-align: middle;
      // position: relative;
      // bottom: 3px;
    }
  }
  .credit {
    float: right;
    width: 124px;
    height: 80px;
    text-align: center;
    position: relative;
    margin-left: 55px;
    font-size: 16px;
    position: relative;
    a {
      position: absolute;
      width: 124px;
      height: 40px;
      line-height: 40px;
      left: 0;
      top: 20px;
      color: #fff;
      background: url("./images/credit.png") no-repeat;
    }
    .qrcode-box {
      display: none;
      position: absolute;
      width: 264px;
      height: 447px;
      top: 60px;
      left: -70px;
      box-sizing: border-box;
      padding: 137px 36px 26px 36px;
      background: url("./images/qrcode-box.png") no-repeat;
      .close-btn {
        position: absolute;
        width: 20px;
        height: 20px;
        top: 145px;
        right: 40px;
        background: url("./images/qrcode-close.png") no-repeat;
        cursor: pointer;
      }
      .qrcode-content {
        width: 160px;
        height: 260px;
        padding: 24px 16px 0px 16px;
        display: none;
        p {
          height: 20px;
          line-height: 20px;
          color: #000000;
          font-size: 12px;
        }
        .qrcode {
          width: 154px;
          height: 154px;
          padding: 4px;
          border: 2px solid #ffc39c;
          margin-top: 5px;
        }
        .foot {
          width: 155px;
          height: 38px;
          margin: 0 auto;
          line-height: 38px;
          text-align: center;
          background: url("./images/qrcode-line.png") no-repeat center;
          color: #000000;
          font-size: 12px;
        }
      }
    }
  }
  .nav {
    li {
      float: right;
      cursor: pointer;
      margin-left: 55px;
      height: 80px;
      a {
        color: #999;
        font-size: 16px;
        padding: 5px 0;
        &:hover {
          color: #ffffff;
          border-bottom: 2px solid #999;
        }
        &.active {
          color: #ffffff;
          border-bottom: 2px solid #999;
        }
      }
    }
  }
  &.white-header {
    .nav {
      li {
        float: right;
        cursor: pointer;
        margin-left: 55px;
        height: 80px;
        a {
          color: #464440;
          font-size: 16px;
          padding: 5px 0;
          &:hover {
            color: #12151f;
            border-bottom: 2px solid #ff3600;
          }
          &.active {
            color: #12151f;
            border-bottom: 2px solid #ff3600;
          }
        }
      }
    }
  }
}
.introduce {
  width: 100%;
  height: 453px;
  background: url("./images/introduce-bg.png") no-repeat top center;
  dl {
    width: 1200px;
    margin: 0 auto;
    height: 300px;
    padding-top: 153px;
    dt {
      font-size: 40px;
      color: #ffffff;
      padding-bottom: 30px;
      background: url("./images/introduce-line.png") no-repeat left bottom;
    }
    dd {
      color: #fff;
      line-height: 25px;
      font-size: 14px;
      width: 730px;
      text-align: justify;
      padding-top: 40px;
    }
  }
}
.corporate-culture {
  width: 100%;
  background-color: #ffffff;
  padding-top: 100px;
  padding-bottom: 160px;
  .title {
    text-align: center;
    width: 184px;
    height: 109px;
    line-height: 109px;
    background: url("./images/icon-02.png") no-repeat;
    margin: 0 auto;
    font-size: 36px;
  }
  ul {
    width: 1200px;
    height: 942px;
    margin: 0 auto;
    padding-top: 75px;
    li {
      width: 600px;
      height: 314px;
      float: left;
      text-align: center;
      background: #ffffff;
      &.illustration-1 {
        background: url("./images/illustration-1.png") no-repeat;
      }
      &.illustration-2 {
        background: url("./images/illustration-2.png") no-repeat;
      }
      &.illustration-3 {
        background: url("./images/illustration-3.png") no-repeat;
      }
      dt {
        padding-top: 10px;
        &.add-top {
          padding-top: 34px;
        }
      }
      .has-line {
        padding-top: 20px;
        padding-bottom: 55px;
        font-size: 30px;
        color: #000000;
        background: url("./images/jianbian-line.png") no-repeat center bottom 20px;
      }
      .word {
        font-size: 16px;
        color: #a7aec1;
        line-height: 30px;
      }
    }
  }
}

.introduce-slide {
  width: 100%;
  padding: 75px 0;
  background-color: #161a1d;
  .title {
    text-align: center;
    width: 184px;
    height: 109px;
    line-height: 109px;
    background: url("./images/icon-03.png") no-repeat;
    margin: 0 auto;
    font-size: 36px;
    color: #ffffff;
  }
  .slide-box {
    width: 448px;
    margin: 0 auto;
    padding: 45px 116px;
    position: relative;
    .item {
      width: 448px;
      height: 500px;
      background-color: #ffffff;
      .img {
        width: 448px;
        height: 300px;
        background-color: #ffffff;
        text-align: center;
        line-height: 300px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .text {
        background-color: #1d2124;
        padding-left: 20px;
        width: 428px;
        height: 200px;
        color: #ffffff;
        h2 {
          line-height: 50px;
          height: 50px;
          padding-top: 25px;
          font-weight: normal;
          font-size: 18px;
        }
        p {
          font-size: 14px;
          line-height: 40px;
          height: 40px;
        }
      }
    }
    .swiper-button-prev {
      top: 184px;
      background-image: url("./images/slide-left.png");
      &:focus {
        outline: none;
      }
    }
    .swiper-button-next {
      top: 184px;
      background-image: url("./images/slide-right.png");
      &:focus {
        outline: none;
      }
    }
  }
  .time-line {
    width: 1197px;
    height: 100px;
    background: url("./images/time-line.png") no-repeat top 15px center;
    margin: 0 auto;
    position: relative;
    overflow: hidden;
    .time-line-box {
      position: absolute;
      left: 0px;
      top: 0px;
    }
    .time-line-item {
      width: 171px;
      height: 100px;
      float: left;
      text-align: center;
      span {
        display: inline-block;
        width: 31px;
        height: 31px;
        cursor: pointer;
        &.selected {
          background: url("./images/selected.png") no-repeat;
        }
        &.not-selected {
          background: url("./images/not-selected.png") no-repeat;
        }
      }
      p {
        font-size: 18px;
        color: #ffffff;
        height: 60px;
        line-height: 60px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// aboutUs.vue?5c7bc064